module.exports = __webpack_public_path__ + "static/media/photo-icon.b2fd2f9e.svg";